import { ReactComponent as UpgradeIcon } from './upgrade.svg'
import styles from './UpgradeButton.module.scss'

const UpgradeButton = ({ handleClick, label }) => (
  <>
    <button
      onClick={handleClick}
      className={styles.container}
      data-tip="Upgrade to group level"
    >
      <UpgradeIcon title={`upgrade ${label}`} />
    </button>
  </>
)

export default UpgradeButton
